module.exports = __webpack_public_path__ + "img/5-1.57332ef6.png";